"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOGGLE_CHECKED = exports.FormStruct = exports.FormPageStruct = exports.FormFieldStruct = exports.FormFieldOptionStruct = void 0;
const superstruct_1 = require("superstruct");
exports.FormFieldOptionStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    value: (0, superstruct_1.string)(),
});
exports.FormFieldStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    label: (0, superstruct_1.string)(),
    position: (0, superstruct_1.number)(),
    defaultValue: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    type: (0, superstruct_1.enums)([
        'number',
        'select',
        'radio',
        'checkbox',
        'toggle',
        'info',
        'text',
        'date',
        'birthdate',
        'phone',
        'email',
        'image-upload',
        'file-upload',
    ]),
    required: (0, superstruct_1.boolean)(),
    options: (0, superstruct_1.optional)((0, superstruct_1.array)(exports.FormFieldOptionStruct)),
});
exports.FormPageStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    position: (0, superstruct_1.number)(),
    title: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    description: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.string)()), ''),
    fields: (0, superstruct_1.array)(exports.FormFieldStruct),
    skipInCounter: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
});
exports.FormStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    name: (0, superstruct_1.string)(),
    color: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    pages: (0, superstruct_1.array)(exports.FormPageStruct),
});
exports.FormFieldOptionStruct.type = 'FormFieldOption';
exports.FormFieldStruct.type = 'FormField';
exports.FormPageStruct.type = 'FormPage';
exports.FormStruct.type = 'Form';
exports.TOGGLE_CHECKED = 'checked';
//# sourceMappingURL=form.js.map